import * as moment from "moment";
import { Moment } from "moment";
import { Document } from "./document";
import { Note } from "./note";

export enum CaseStatus {
  OPENED = 'OPENED',
  CLOSED = 'CLOSED'
}

export enum CaseType {
  PRINCIPAL = 'PRINCIPAL',
  COUNTERCLAIM = 'COUNTERCLAIM',
  RENEWAL_MAINTENANCE = 'RENEWAL_MAINTENANCE',
}


export interface CaseAttachment {
  _id?: string;
  case: string;
  name: string;
  description?: string;
  type: string;
  appendix?: boolean;
  blobKey?: string;
  nonUse?: boolean;
  document?: string;
  uploader: {
    ref: string;
    firstName: string;
    lastName: string;
    avatar: string;
  };
  organizationId: string;
}

export type CaseDocument = Document & { score: number };

export interface CaseScore {
  global: number,
  documentsCount: number,
  documentsAccuracy: number,
  documentsClasses: number,
  temporalCoverage: number
}

export const SuspendedLabel = 'suspended';

export const ClosedDecisionArray = ['LOST', 'MITIGATED', 'WON'] as const;
type ClosedDecision = typeof ClosedDecisionArray[number];
export interface ClosedPhaseMeta { withdrawal: boolean, decision: ClosedDecision, definitive: boolean }

export interface CasePossiblePhase {
  duration: string,
  method: string,
  status: CaseStatus
}

export interface Case {
  _id?: string;
  identifier?: string;
  reference: string; // Define with First 3 letter or less + time or other attributes + 6 (or less) random char
  type: CaseType;
  trademark: {
    ref: string,
    name: string;
    identifierNumber: string;
    countryOfDesignation: string;
  };
  propertyOffice?: string; // TODEFINE useful or not according to trademark office
  niceClassification: number[],
  productsServices?: {
    ref: string;
    label: string;
    classNumber: number;
    trademark: string;
  }[];
  createdAt: Date,
  timePeriod: {
    start: Moment,
    end: Moment
  };
  lang: string;
  documents?: { ref: string, score: number }[];
  owner?:
  {
    ref: string;
    firstName: string;
    lastName: string;
    avatar: string;
  },
  // users : []  Part 2,
  score: CaseScore,
  notes: Note[],
  organizationId?: string;
  state: CaseStatus;
}

export function caseComparator(a: Case, b: Case) {
  const dateA: Date = typeof a.timePeriod.end === "string" ? new Date(a.timePeriod.end) : a.timePeriod.end.toDate();
  const dateB: Date = typeof b.timePeriod.end === "string" ? new Date(b.timePeriod.end) : a.timePeriod.end.toDate();
  return dateA.getTime() - dateB.getTime();
}